module.exports = __webpack_public_path__ + "img/tarj3-4.35c3aafc.svg";